// extracted by mini-css-extract-plugin
export default {"toggleLabel":"Toggle_toggleLabel__vLIJT","toggleCheckbox":"Toggle_toggleCheckbox__JJEop","spin":"Toggle_spin__KaExF"};